export const createAppoinment = async (bbdd, idCompany, user, event, idResponsable = null, lexonToken) => {
  let url = `${window.API_GATEWAY}/api/v1/lexauth/Appointments/${idCompany}/user/${user.idUser}/conn/${bbdd}/appointments`;
  if (window.currentUser?.env) {
    url = `${url}?env=${window.currentUser.env}`;
  }
  if (window.currentUser?.env && idResponsable) {
    url = `${url}&idResponsable=${idResponsable}`;
  }

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${lexonToken}`
    },
    body: JSON.stringify({
      id: parseInt(event.Id, 10),
      bbdd,
      subject: event.Subject,
      idEvent: event.Guid,
      provider: 'IM',
      startDate: event.StartTime,
      endDate: event.EndTime,
      allDay: event.AllDay ? 1 : 0,
      calendar: {
        id: event.calendar.id,
        title: event.calendar.summary,
        description: '',
        color: event.calendar.backgroundColor,
        fgColor: event.calendar.backgroundColor
      },
      guests: event.Attendees || event.attendees ? 
        (event.Attendees || event.attendees).map((a) => a.email) : [],
      reminder: (() => {
        const getMinutesBefore = e => {
          if (e.minutes) {
            return e.minutes;
          } else if (e.trigger) {
            return e.trigger;
          }
          return 0;
        };
        if (event.Reminders) {
          return event.Reminders.map(e => ({ method: e.method, minutesBefore: getMinutesBefore(e) }));
        } else if (event.reminders) {
          return event.reminders.map(e => ({ method: e.method, minutesBefore: getMinutesBefore(e) }));
        }
        return [];
      })(),
      account: event.Account,
      importado: event.Importado
    })
  });
  const result = await response.json();

  return { result };
};

export const addEventToActuation = async (
  bbdd,
  idCompany,
  idUser,
  eventId,
  actuationId,
  token
) => {
  let url = `${window.API_GATEWAY}/api/v1/lexauth/Appointments/${idCompany}/user/${idUser}/conn/${bbdd}/appointments/relation`;
  if (window.currentUser.env) {
    url = `${url}?env=${window.currentUser.env}`;
  }
  const bodyRequest = {
    idAppointment: eventId,
    idAction: actuationId
  };

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(bodyRequest)
  });
  const result = await response.json();

  return { result };
};

export const updateAppoinment = async (bbdd, idCompany, idEventAction, user, event, token, idResponsable = null) => {
  let url = `${window.API_GATEWAY}/api/v1/lexauth/Appointments/${idCompany}/user/${user.idUser}/conn/${bbdd}/appointments`;
  if (window.currentUser.env) {
    url = `${url}?env=${window.currentUser.env}`;
  }
  if (window.currentUser.env && idResponsable) {
    url = `${url}&idResponsable=${idResponsable}`;
  }
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      id: parseInt(idEventAction, 10),
      bbdd: bbdd,
      allDay: event.allDay ? 1 : 0,
      subject: event.summary,
      idEvent: event.Guid,
      provider: 'IMAP',
      startDate: event.StartTime,
      endDate: event.EndTime,
      calendar: {
        id: event.calendar.id,
        title: event.calendar.summary,
        description: '',
        color: event.calendar.backgroundColor,
        fgColor: event.calendar.foregroundColor
      },
      guests: event.Attendees || event.attendees ? 
        (event.Attendees || event.attendees).map((a) => a.email) : [],
      reminder: event.Reminders
        ? event.Reminders.map(e => {
          let minutesBefore = 0;
          if (e.minutes) {
            minutesBefore = e.minutes;
          } else if (e.trigger) {
            minutesBefore = e.trigger;
          }
          return { method: e.method, minutesBefore };
        })
        : [],
      account: event.Account
    })
  });
  const result = await response.json();
  return { result };
};

export const getUser = async (entry, idNavision, token) => {
  let url = `${window.API_GATEWAY}/api/v1/lexauth/Lexon/user/?entry=${entry}&idNavision=${idNavision}`;
  if (window.currentEnv) {
    url += `&env=${window.currentEnv}`;
  }
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  const response = await fetch(url, { method: "GET", headers: myHeaders });
  const result = await response.json();
  const user = result.data;
  return user;
};

export const removeAppoinmentByAppoitmentId = async (
  bbdd,
  idCompany,
  idEventAction,
  entry,
  idNavision,
  token
) => {
  const user = await getUser(entry, idNavision, token);
  const lexUser = user.idUser;

  let url = `${window.API_GATEWAY}/api/v1/lexauth/Appointments/${idCompany}/user/${lexUser}/conn/${bbdd}/appointments/${idEventAction}`;
  if (window.currentUser.env) {
    url = `${url}?env=${window.currentUser.env}`;
  }
  const response = await fetch(url, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({})
  });
  const result = await response.json();
  return result;
};

export const removeAppoinment = async (bbdd, idCompany, idActuation, entry, idNavision, token) => {
  const user = await getUser(entry, idNavision, token);
  const lexUser = user.idUser;

  let url = `${window.API_GATEWAY}/api/v1/lexauth/Appointments/${idCompany}/user/${lexUser}/conn/${bbdd}/appointments/relation/${idActuation}`;
  if (window.currentUser.env) {
    url = `${url}?env=${window.currentUser.env}`;
  }
  const response = await fetch(url, {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({})
  });
  const result = await response.json();
  return result;
};
